import { Ajax } from "../Extensions/ajax";
import { Form } from "../Extensions/form";

export default function () {
    const forms = Array.from(document.body.querySelectorAll("form.js-ajax-form"));
    forms.forEach(form => form.addEventListener("submit", onSubmit));

    const wrapWithSender = (s, cb) => d => { cb(s, d); };

    function onSubmit(e) {
        e.preventDefault();
        const form = e.target;
        const action = form.getAttribute("action");
        const data = Form.serialize(form);
        Ajax.post(action, data, wrapWithSender(form, onSuccess), wrapWithSender(form, onError));
        this.submitCallback && this.submitCallback();
    };

    function onSuccess(sender, data) {
        sender.successCallback && sender.successCallback(data);
    };

    function onError(sender, data) {
        sender.errorCallback && sender.errorCallback(data);
    };
};


// WEBPACK FOOTER //
// ./uPortal/Content/js/AjaxForms/formSubmit.js